module.exports = __webpack_public_path__ + "img/hadamard-line-short.309dbb79.svg";